<template>
  <div>
    <b-loading
      :is-full-page="true"
      :can-cancel="false"
      v-model="loadingPage"
    ></b-loading>
    <div v-if="deviceType > 1" class="mobile-navigation">
      <toolbar @on-menu-click="openMenu"></toolbar>
      <mobile-menu></mobile-menu>
      <div class="mobile-navigation__content">
        <router-view></router-view>
      </div>
    </div>

    <div v-if="deviceType == 1" class="desktop-navigation">
      <side-bar v-if="!hideSidebar"></side-bar>
      <div class="desktop-navigation__content">
        <nav-bar></nav-bar>
        <router-view class="layout-router"></router-view>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import SideBar from '@/components/navigation/desktop/SideBar.vue'
import MobileMenu from '@/components/navigation/mobile/MobileMenu.vue'
import Toolbar from '@/components/navigation/mobile/Toolbar.vue'
import NavBar from '@/components/navigation/desktop/NavBar.vue'
import { mapActions, mapMutations, mapState } from 'vuex'

export default Vue.extend({
  name: 'MainLayout',

  components: { SideBar, MobileMenu, Toolbar, NavBar },

  methods: {
    ...mapActions(['signout']),
    ...mapActions('navigation', ['setSidebarExpanded']),
    ...mapMutations(['SHOW_SIGNOUT_DIALOG']),
    ...mapMutations('navigation', ['SET_WIDTH_WINDOW']),

    openMenu() {
      this.setSidebarExpanded(true)
    },

    openSignoutAlert() {
      this.$buefy.dialog.confirm({
        title: 'Cerrar sesión',
        message:
          'La sesión actual será finalizada y se enviará a la pantalla de acceso ¿Deseas continuar?',
        confirmText: 'Salir',
        cancelText: 'Cancelar',
        type: 'is-warning',
        hasIcon: true,
        onCancel: () => this.SHOW_SIGNOUT_DIALOG(false),
        onConfirm: () => this.signout()
      })
    },

    getDimensions() {
      this.SET_WIDTH_WINDOW(window.innerWidth)
    }
  },

  computed: {
    ...mapState(['signoutOpen']),
    ...mapState('navigation', ['hideSidebar', 'loadingPage', 'deviceType'])
  },

  watch: {
    signoutOpen(newValue) {
      if (newValue) {
        this.openSignoutAlert()
      }
    }
  },

  mounted() {
    this.getDimensions()
    window.addEventListener('resize', this.getDimensions)
  },

  destroyed() {
    window.removeEventListener('resize', this.getDimensions)
  }
})
</script>

<style lang="sass" scoped>
@import @/assets/sass/mixins
@import @/assets/sass/colors
@import @/assets/sass/common

.layout-router
    overflow-y: auto
.mobile-navigation
  display: flex
  flex-direction: column
  width: 100%

  &__content
    padding: 16px 0px
    height: calc(100vh - 64px)
    overflow-y: auto

  @include respond-to("desktop")
    display: none

.desktop-navigation
  display: flex
  flex-direction: row
  width: 100%
  //height: calc(100vh -  80px)

  &__content
    display: flex
    flex-direction: column
    width: 100%
    height: 100vh
    overflow-y: hidden
    background-color: $white

  @include respond-to("phone")
    display: none

  @include respond-to("desktop")
    display: flex
    background: $background
</style>
